import { AppData } from '../models/appdata'
import { Injectable, Inject, Injector } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
//import { URLSearchParams, Response, HttpModule, Headers } from '@angular/http';
import { APP_BASE_HREF } from '@angular/common';
//import { Observable } from 'rxjs/Observable';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
//import 'rxjs/add/operator/retry';
import { UserAccountRequest } from '../models/login/useraccountrequest';
import { Router } from '@angular/router';

import { LoginRequest, IsSessionExistsRequest, AppUserSettingRequest } from '../models/login/loginrequestmodel';
import { ApiResponseModel } from '../models/api_response_model';
import { CustomerAppSettings } from '../models/CustomerAppSettings';
import { CustomerAppSettingsReader } from '../models/CustomerAppSettingsReader';


@Injectable()
export class LoginService {
  public cas: CustomerAppSettings;
  // get
  //save
  //x for indicate operation

  constructor(private http: HttpClient, private injector: Injector,
    private router: Router, private casReader: CustomerAppSettingsReader) {



  }
  public xGetSettings() {
    return this.casReader.getSettings();//.subscribe(settings => this.cas = settings,
    //() => { }, () => {
  }
  public xGetProfileSettings(branch: string) {
    return this.casReader.getProfileSettings(branch);//.subscribe(settings => this.cas = settings,
    //() => { }, () => {
  }
  //: Observable<ApiResponseModel>
  xLoginRequest(xLoginRequest: LoginRequest) {
    //this.xGetSettings().subscribe(settings =>
    //{
    //  this.cas = settings;
    //  AppData.GlobalApiUrl = this.cas.GlobalApiUrl;
    //},
    //  () => { }, () => {
    //alert("xLoginRequest===="+AppData.GlobalApiUrl);
    return this.http.post<ApiResponseModel>
      (`${AppData.GlobalApiUrl}Login/xLoginRequest`,
        (xLoginRequest),
        {

        }

      ).pipe(catchError(this.handleError));
    //});
    //alert(`${AppData.GlobalApiUrl}Login/xLoginRequest`);
    //return this.http.get('http://google.com', null)
    //  .pipe(catchError(this.handleError));  
  }


  xIsSessionExists(xIsSessionExistsRequest: IsSessionExistsRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Login/xIsSessionExists`, (xIsSessionExistsRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)

      }

    ).pipe(catchError(this.handleError));
  }
  //
  GetAppUserSettingInfoController(SendAppUserSettingRequest: AppUserSettingRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}Login/GetAppUserSettingInfo`, (SendAppUserSettingRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)

      }

    ).pipe(catchError(this.handleError));
  }
  //

  private handleError(error: any) {

    if (error.status === 400) {

      return Promise.reject('Request Failed Due to Bad Request..!');
    }
    //else if (error.status === 401) {
    //  return this.unauthorised();
    //  //return Promise.reject('UnAuthorised Request..!');

    //}
    else if (error.status === 401) {

      //  this.router.navigate(['login']);;;
      //return this.unauthorised();
      return Promise.reject('401 - Unauthorized');

    }
    else if (error.status === -1212401) {

      //  this.router.navigate(['login']);;;
      return this.unauthorised();
      //return Promise.reject('UnAuthorised Request..!');

    }
    else if (error.status === 500) {
      return Promise.reject('Internal Server Error..!');

    }
    else {

      alert(error.message);
      alert(error.statusText);
      let errMsg = (error.message) ? error.message :
        error.status ? `${error.status} - ${error.statusText}` : 'Server error';
      return Promise.reject(error.message || error);
    }
  }
  unauthorised(): Observable<any> {

    this.router.navigate(['signinpage']);
    return throwError(() => ({}));
  }

}
